import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';
import { LayoutsEntry } from '../../components/LayoutsEntry';
import { LayoutsIcon } from '../../components/LayoutsEntry/parts/LayoutsIcon';
import { getHasTour, getLayoutsInfoText } from '../../selectors/newbuilding';
import { isLayoutExperimentEnable } from '../../selectors/offers';
import { trackLayoutEntryClick, trackLayoutWith3DTourEntryClick, trackLayoutWith3DTourEntryShow } from './tracking';

export function LayoutsOrTourEntry() {
  const layoutsInfoText = useSelector(getLayoutsInfoText);
  const hasTour = useSelector(getHasTour);
  const isAbExperiments = useSelector(isLayoutExperimentEnable);

  const infoText = hasTour ? 'Планировки и 3D-туры по квартирам в этом жилом комплексе' : layoutsInfoText;
  const icon = <LayoutsIcon />;
  const trackClick = hasTour ? trackLayoutWith3DTourEntryClick : trackLayoutEntryClick;

  const onLayoutEntryClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#layouts',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackClick();
  };

  const onLayoutEntryShow = () => {
    if (hasTour) {
      trackLayoutWith3DTourEntryShow();
    }
  };

  if (!infoText || isAbExperiments) {
    return null;
  }

  return (
    <ActionAfterViewed callback={onLayoutEntryShow}>
      <LayoutsEntry infoText={infoText} icon={icon} onClick={onLayoutEntryClick} />
    </ActionAfterViewed>
  );
}
